<ng-container *ngFor="let position of positions">

  <div [ngClass]="getPositionClasses(position)" class="fixed flex flex-col gap-4 z-50">
    <app-toast-notification *ngFor="let notification of groupedNotifications[position]" [message]="notification.message"
      [type]="notification.type" [title]="notification.title" (closeNotification)="removeNotification(notification, position)">
    </app-toast-notification>
  </div>
</ng-container>
